<script setup>
setPageTitle(PageMeta.Orders.Add.Title)
definePage({ meta: PageMeta.Orders.Add.Meta })

import OrdersCreatePage from '@/views/Previews/Orders/OrdersCreatePage.vue'
</script>

<template>
  <OrdersCreatePage />
</template>
